import * as JobTypes from "../../types/jobData";
import { FilterStateManager } from "../filterStateManager";
import { JobOverviewPage } from "../jobOverviewPage";
import { FeaturedJobsWorker } from "./featuredJobsWorker";
import { JobFinder } from "../jobFinder";
import { flatFeaturedJob } from "../../types/featuredJobList";

/**
 * 💡 Purpose
 * - This class is responsible for managing the featured jobs filter.
 * */
export class FeaturedFilter {
  private filterData: flatFeaturedJob[] = [];

  private hasDataLoaded: boolean = false;

  private currentFeaturedJobs: JobTypes.jobData[] = [];

  private currentFeaturedJobIds: number[] = [];
  constructor(private JobOverviewPage: JobOverviewPage, private filterStateManagerInstance: FilterStateManager) {}

  initialize(filterData: flatFeaturedJob[]) {
    this.filterData = filterData;
    console.log("FilterData is:", this.filterData);
    this.hasDataLoaded = true;
  }

  /**
   * Returns all featured job ID's that match exact the active filters.
   *
   * @returns {number[]} - Array of job IDs
   */
  getFeaturedJobs(): JobTypes.jobData[] {
    if (!this.hasDataLoaded) {
      console.log("FeaturedFilter: No Data available");
      return [];
    }
    this.currentFeaturedJobs = []; // Reset current featured jobs

    const workerInstance = new FeaturedJobsWorker(this.filterData, this.filterStateManagerInstance.getActiveFilters());

    const matchingJobIds = workerInstance.findMatchingJobIDs();
    this.currentFeaturedJobIds = matchingJobIds;
    let foundJobs = JobFinder.findJobsByID(matchingJobIds, this.JobOverviewPage.getAllJobs);

    //Sort the array by publication date
    foundJobs.sort((a, b) => {
      const dateA = new Date(a.jobOpening.createdDate);
      const dateB = new Date(b.jobOpening.createdDate);
      return dateB.getTime() - dateA.getTime(); // Sort in descending order
    });

    this.currentFeaturedJobs = foundJobs;
    return foundJobs;
  }

  getCurrentFeaturedJobs(): JobTypes.jobData[] {
    return this.currentFeaturedJobs;
  }

  getCurrentFeaturedJobIds(): number[] {
    return this.currentFeaturedJobIds;
  }
}
